import { Box, Tooltip, Typography } from '@mui/material'
import Grid from '@mui/material/Unstable_Grid2/Grid2'
import { useContext, useEffect, useState } from 'react'
import { WebSocketContext } from '../../Providers/WebSocket/WebSocketContext'
import FigmaTable from '../FigmaTable/FigmaTable'
import { CondominiosContext } from '../../Providers/CondominiosContext/CondominiosContext'
import { PhotoCameraFront, RemoveRedEye } from '@mui/icons-material'
import Video from '../Video/Video'
import ComboBox from '../ComboBox/ComboBox'
import VisualizacaoEvento from '../../Pages/GestaoEventos/VisualizacaoEvento/VisualizacaoEvento'
import OneDatePicker from '../OneDatePicker/OneDatePicker'
import moment from 'moment'
import { showNotify } from '../../Utils/Utils'

const newSx = {
    input: {
        height: { xs: '30px', lg: '21px', xl: '30px' },
        width: { xs: '100px', lg: '150px', xl: '200px' },
        fontSize: { lg: '10px', xl: '15px' }
    },
    label: {
        fontSize: { lg: '13px', xl: '15px' }
    }
}

const HistoricoEventos = () => {
    const { addRoute, sendWs } = useContext(WebSocketContext)
    const { activeCond } = useContext(CondominiosContext)

    const [listaEventos, setListaEventos] = useState(null)
    const [listaPrioridades, setListaPrioridade] = useState()
    const [eventos, setEventos] = useState([])
    const [formData, setFormData] = useState({
        condominio: activeCond.id_central,
        dt_inicial: moment().startOf('day').format('yyyy-MM-DD HH:mm'),
        dt_final: moment().endOf('day').format('yyyy-MM-DD HH:mm'),
        eventos: []
    })
    const [page, setPage] = useState(1)
    const [openVideo, setOpenVideo] = useState(false)
    const [titleVideo, setTitleVideo] = useState("")
    const [eventId, setEventId] = useState("")
    const [cameraId, setCameraId] = useState("")
    const [openEvento, setOpenEvento] = useState(false)
    const [idToView, setIdToView] = useState(null)

    const columns = [
        {
            name: 'Evento',
            cell: row => rowEvento(row.evento, row.descricao, row.prioridade),
            style: {
                width: '25%'
            }
        },
        {
            name: 'Tag',
            cell: row => (!row.tag || row.tag == 0) ? "" : row.tag,
            style: {
                width: '10%'
            }
        },
        {
            name: 'Hora',
            cell: row => row.dt_criacao ? row.dt_criacao : "",
            style: {
                width: '10%'
            }
        },
        {
            name: 'Usuário',
            cell: row => row.usuario_morador ? row.usuario_morador : "",
            style: {
                width: '15%'
            }
        },
        {
            name: 'Imóvel',
            cell: row => row.imovel ? row.imovel : "",
            style: {
                width: '10%'
            }
        },
        {
            name: 'Auxiliar',
            cell: row => row.complemento
                ? <span style={{
                    width: '10px',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                }} >{row.complemento}</span>
                : "",
            style: {
                width: '10%'
            }
        },
        {
            name: '',

            cell: row => row.ids_camera_gravacao
                ? <PhotoCameraFront
                    titleAccess="Ver vídeo"
                    cursor="pointer"
                    sx={{ alignSelf: 'center', alignContent: 'center', justifySelf: 'center', fontSize: '18px' }}
                    onClick={() => {
                        setEventId(row.id)
                        setTitleVideo(`${row.evento}-${row.descricao}`)
                        setCameraId(row.ids_camera_gravacao.split(',')[0])
                        setTimeout(() => {
                            openModalVideo()
                        }, 10)
                    }} />
                : "",
            style: {
                width: '1%',
                textAlign: 'center'
            }
        },
        {
            name: '',

            cell: row => <RemoveRedEye
                titleAccess="Ver evento"
                cursor="pointer"
                sx={{ alignSelf: 'center', alignContent: 'center', justifySelf: 'center', fontSize: '18px' }}
                onClick={() => {
                    handleViewEvent(row.id)
                }} />,
            style: {
                width: '1%',
                textAlign: 'center'
            }
        }
    ]

    const rowEvento = (ev, descricao, prioridade) => {
        const color = getColorPrioridade(prioridade)
        const pri_str = getPrioridadeStr(prioridade)
        const evento = (ev ? `${ev}-${descricao}` : "")
        return (
            <Tooltip title={`Prioridade: ${pri_str}`} placement="left" arrow>
                <Box sx={{ display: "flex", alignItems: 'center', gap: '5px', width: '100%', flexWrap: 'wrap', overflow: 'hidden' }}>
                    <Box sx={{ backgroundColor: color, width: '12px', height: '12px', borderRadius: '50%' }}></Box>
                    <Box>{evento}</Box>
                </Box>
            </Tooltip>
        )
    }

    /*
        1 - Baixa - Verde - rgb(14, 194, 69)
        2 - Média - Azul - rgb(0, 92, 254)
        3 - Alta - Laranja - rgb(255, 144, 0)
        4 - Crítica - vermelho - rgb(255, 1, 0)
    */
    const getColorPrioridade = (pri) => {
        let color = ""
        switch (pri) {
            case 1:
                color = 'rgb(14, 194, 69)'
                break
            case 2:
                color = 'rgb(0, 92, 254)'
                break
            case 3:
                color = 'rgb(255, 144, 0)'
                break
            case 4:
                color = 'rgb(255, 1, 0)'
                break
            default:
                break
        }
        return color
    }
    const getPrioridadeStr = (pri) => {
        let color = ""
        switch (pri) {
            case 1:
                color = 'Baixa'
                break
            case 2:
                color = 'Média'
                break
            case 3:
                color = 'Alta'
                break
            case 4:
                color = 'Crítica'
                break
            default:
                break
        }
        return color
    }

    const handleViewEvent = (id) => {
        setIdToView(id)
        setOpenEvento(true)
    }

    const getListaEventos = (msg) => {
        let eventosBack = []
        let prioridades = [{ id: "0", descricao: "Todas" }]
        if (msg.data.status) {
            msg.data.listagens.evento.map(evento => {
                eventosBack.push({ id: evento.evento, descricao: `${evento.evento}-${evento.descricao}` })
                if (!prioridades[evento.prioridade]) {
                    prioridades[evento.prioridade] = { id: `${evento.prioridade}`, descricao: `${getPrioridadeStr(evento.prioridade)}` }
                }
            })
            setListaEventos(eventosBack)
            setListaPrioridade(prioridades)
        }
    }

    const openModalVideo = () => {
        setOpenVideo(true)
    }

    const getEventos = (msg) => {
        if (msg.data.status) {
            const columns = msg.data.eventos.eventos
            if (msg.data.filtros.maisDados) {
                eventos.pop()
                const eventosBack = [...eventos, ...columns]
                if (eventosBack.length < msg.data.eventos.totalEventos[0].total) {
                    eventosBack.push(
                        {
                            usuario_morador: <span
                                onClick={() => buscarEventos(true)}
                                style={{ fontSize: '13px', cursor: 'pointer' }}
                            >
                            Mostrar +
                            </span>
                        }
                    )
                }
                setEventos(eventosBack)
            } else {
                if (columns.length < msg.data.eventos.totalEventos[0].total) {
                    columns.push({
                        usuario_morador: <span onClick={() => buscarEventos(true)} style={{ fontSize: '13px', cursor: 'pointer' }}>Mostrar +</span>
                    })
                }
                setEventos(columns)
            }
        } else {
            showNotify("Erro", "Erro ao buscar eventos", "error")
        }
    }

    const buscarEventos = (maisDados = false) => {
        sendWs("getGestaoEventos", {
            filtros: { ...formData, maisDados },
            // rgs: (eventos.length == 0 ? 20 : eventos.length - 1),
            rgs: 20,
            page: maisDados ? page + 1 : page
        })

        if (maisDados) {
            setPage(page + 1)
        } else {
            setPage(1)
        }
    }

    addRoute("getGestaoEventos", getEventos)
    useEffect(() => {
        if (listaEventos != null) {
            buscarEventos()
        } else {
            if (activeCond != formData.condominio) {
                setFormData({ ...formData, condominio: activeCond.id_central })
            }
            addRoute("buscarListagens#historicoEventos", getListaEventos)
            sendWs("buscarListagens#historicoEventos", {
                listagens: {
                    evento: ["id", "evento", "descricao", "prioridade"]
                }
            })
            buscarEventos()
        }
    }, [activeCond, formData.dt_inicial, formData.dt_final, formData.eventos, formData.prioridade])

    const handleChange = async (event) => {
        let newFormData = { ...formData }
        if (event.target.value != undefined) {
            if (event.target.name == 'eventos' && event.target.value != '0') {
                newFormData.eventos = [event.target.value]
            } else if (event.target.name == 'eventos' && event.target.value == '0') {
                newFormData.eventos = []
            } else {
                newFormData[event.target.name] = event.target.value
            }
            setFormData(newFormData)
        }
    }

    const handleRowDoubleClick = (row) => {
        handleViewEvent(row.id)
    }

    return (
        <>
            {openVideo &&
                <Video
                    open={openVideo}
                    setOpen={setOpenVideo}
                    title={titleVideo}
                    eventId={eventId}
                    cameraId={cameraId}
                />
            }
            {openEvento &&
                <VisualizacaoEvento
                    openEvento={openEvento}
                    setOpenEvento={setOpenEvento}
                    idToView={idToView}
                    setIdToView={setIdToView}
                    naoOuvirAudio={true}
                />
            }
            <Box container="true" sx={{
                gap: '7px',
                alignItems: 'self-start',
                width: '100%',
                height: '100%',
                display: 'flex',
                flexDirection: 'column'
            }} >
                <Grid container xs={12} sx={{ gap: 1, flexWrap: 'nowrap', paddingTop: '5px' }}>
                    <Grid xs={1} ><span style={{ fontWeight: 600 }}>Eventos</span></Grid>

                    <Grid sx={{ alignItems: 'center' }}>
                        <Typography sx={filtrosTypography}>Data Inicial: </Typography>
                        <OneDatePicker
                            name="dt_inicial"
                            defaultValue={formData.dt_inicial}
                            callback={handleChange}
                        />

                    </Grid>

                    <Grid sx={{ alignItems: 'center' }}>
                        <Typography sx={filtrosTypography}>Data Final: </Typography>
                        <OneDatePicker
                            name="dt_final"
                            defaultValue={formData.dt_final}
                            callback={handleChange}
                        />

                    </Grid>

                    <Grid sx={{ alignItems: 'center' }}>
                        <Typography sx={filtrosTypography}>Evento: </Typography>
                        { listaEventos &&
                        <ComboBox
                            newSx={newSx.input}
                            defaultValue={'0'}
                            name="eventos"
                            options={[{ id: '0', descricao: 'Todos' }, ...listaEventos]}
                            todos={true}
                            onChange={handleChange}
                        />
                        }
                    </Grid>

                    <Grid xs={2.75} sx={{ alignItems: 'center' }}>
                        <Typography sx={filtrosTypography}>Prioridade: </Typography>

                        { listaPrioridades &&
                        <ComboBox
                            newSx={newSx.input}
                            defaultValue={'0'}
                            name="prioridade"
                            options={listaPrioridades}
                            todos={true}
                            onChange={handleChange}
                        />
                        }
                    </Grid>
                </Grid>
                <Grid xs={12} sx={{
                    width: '100%',
                    display: 'flex',
                    overflowY: 'scroll',
                    flexGrow: 1
                }}>
                    <Grid sx={{ height: '100%', width: '100%' }}>
                        {eventos &&
                        <FigmaTable
                            data={eventos}
                            columns={columns}
                            hover={true}
                            onRowDoubleClick={handleRowDoubleClick}
                        />
                        }
                    </Grid>
                </Grid>
            </Box>
        </>
    )
}

export default HistoricoEventos

const filtrosTypography = {
    color: 'white', fontSize: '12px', whiteSpace: 'nowrap'
}
